const PERMISSION_KEY= "personalize:integration_log";
const PAGE_URL = {
    INTEGRATION_LOG_PAGE: "/admin/personalize/integration-log"
}

export {PERMISSION_KEY, PAGE_URL}

